import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { School } from '../models/school';
import { GlobalConstantsComponent } from '../shared/global-constants/global-constants.component';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SchoolService {
  constructor(private httpService: HttpClient,
    @Inject(PLATFORM_ID) private platformId) {
      this.isBrowser = isPlatformBrowser(platformId);
    }

  apiUrl = GlobalConstantsComponent.apiURL;
  public currentSchool: School;
  public jokes: any = [];
  isBrowser;

  public getAll(): Observable<School[]> {
    return this.httpService.get<School[]>(this.apiUrl + `schools`);
  }

  public getBySlug(slug): Observable<School> {
    return this.httpService.get<School>(this.apiUrl + `school/` + slug);
  }

  public getGroupBySlug(slug): Observable<School> {
    return this.httpService.get<School>(this.apiUrl + `schools/group/` + slug);
  }

  public getBySearch(search): Observable<School> {
    return this.httpService.get<School>(this.apiUrl + `school/search/` + search);
  }

  setCurrent(school: School) {
    if (this.isBrowser){
      if (localStorage) {
        localStorage['currentSchool'] = JSON.stringify(school);
      }
      this.currentSchool = school;
    }
  }
  getCurrent() {
    if (this.isBrowser){
      if(this.currentSchool){
        if (localStorage && localStorage['currentSchool']) {
          return JSON.parse(localStorage['currentSchool']);
        }
      }
    }
    return false;
  }

  public getSchoolsCities(): Observable<any> {
    return this.httpService.get<any>(this.apiUrl + `schools/getCities`);
  }

  public getSchoolsFromCity(city): Observable<any> {
    return this.httpService.get<any>(this.apiUrl + `schools/getSchoolsFromCity/` + city);
  }

  public getStartingElements(){
    return this.httpService.get<any>(this.apiUrl + `getStartingCities` );

  }
}
